export default 'penpal' as const;
